import './_aerial-map.scss';
import './_aerial-map-pin.scss';
import { responsive, debounce, hammerIt } from '../../../utilities';

export default function initPins($pins, imgW) {
    $pins.each((_, pin) => {
        let transformPos = 'top left';
        const $pin = $(pin);
        const h = $pin.height();
        const isArrDown = $pin.hasClass('arrow-down');
        const isArrRight = $pin.hasClass('arrow-right');
        const t = Number($pin.attr('data-top'));
        const l = Number($pin.attr('data-left'));

        const defaultW = 1440;
        const defaultH = 900;
        const tPercent = (t / defaultH) * 100;
        const lPercent = (l / defaultW) * 100;

        if (isArrRight) {
            $pin.css('right', `${lPercent}%`);
        } else {
            $pin.css('left', `${lPercent}%`);
        }

        if (!isArrDown) {
            $pin.css('top', `${tPercent}%`);
            transformPos = 'top left';

            if (isArrRight) {
                transformPos = 'center right';
            }

            responsive.transformScale(pin, imgW, 1440, transformPos);
        } else {
            const bPercent = ((defaultH - t - h) / defaultH) * 100;
            $pin.css('bottom', `${bPercent}%`);
            transformPos = 'bottom left';

            responsive.transformScale(pin, imgW, 1440, transformPos);
        }
    });
}

$(() => {
    const $aerialMap = $('.aerial-map');
    if (!$aerialMap.length) {
        return;
    }
    const $imgContainer = $aerialMap.find('.aerial-map__img-container'); // image container

    function initFootNote() {
        // scale footNote
        const $footNote = $aerialMap.find('.aerial-map__map-footnote');
        responsive.fontScale(
            $footNote.find('p').get(0),
            responsive.breakpoints.md,
            responsive.breakpoints.xxl,
            5,
            9
        );
        // set equal height for footnote background
        const footNoteBg = $aerialMap.find('.aerial-map__map-footnote--bg');
        footNoteBg.css('height', `${$footNote.outerHeight()}px`);
    }

    function resize() {
        responsive.breakAt({
            callback: () => {
                // initDesktopScrollEffect();
                initFootNote();
                // init pins
                initPins($aerialMap.find('.aerial-map__pin'), $imgContainer.outerWidth());
                // pinch zoom
                hammerIt(document.querySelector('.aerial-map .aerial-map__img-container '), 1, 2);
            },
            from: 'md',
        });
    }

    resize();
    window.addEventListener('resize', debounce(resize, 300));
});
